"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INetworkAnalysisNetworkSerializedSchema = void 0;
const zod_1 = require("zod");
const INetworkAnalysisPort_1 = require("./INetworkAnalysisPort");
const INetworkAnalysisDependency_1 = require("./INetworkAnalysisDependency");
const SerializedElectricalSchematicView_1 = require("../SerializedElectricalSchematicView");
exports.INetworkAnalysisNetworkSerializedSchema = zod_1.default.object({
    network: SerializedElectricalSchematicView_1.SerializedElectricalSchematicViewSchema,
    ports: INetworkAnalysisPort_1.INetworkAnalysisPortSchema.array(),
    dependencies: INetworkAnalysisDependency_1.INetworkAnalysisDependencySchema.array(),
});
//# sourceMappingURL=NetworkAnalysisNetwork.js.map